import { createPopper } from '@popperjs/core';
import ClipboardJS from 'clipboard';

export default class Share {
  static DefaultOptions = {
    elementClass: 'share',
    shareListClass: 'share__list',
    shareButtonClass: 'share__button',
    shareCloseClass: 'share__list-close',
    shareListArrowClass: 'share__list-arrow',
    shareListTextClass: 'cta-link__text',
    initializedModifier: 'share--initialized',
  };

  /**
   *
   * @param {HTMLElement} $el The dom element to be made into a share
   * @param {{
   *  shareListClass: string,
   *  shareButtonClass: string,
   *  shareCloseClass: string,
   *  shareListArrowClass: string,
   *  shareListTextClass: string,
   *  initializedModifier: string
   * }} options Additional js options
   */
  constructor($el, options = {}) {
    this.$el = $el;
    this.options = {
      ...Share.DefaultOptions,
      ...options,
    };

    this.init();
  }

  init(popperPlacement = 'bottom') {
    if (this.$el) {
      this.$button = this.$el.querySelector(`.${this.options.shareButtonClass}`);
      this.$shareList = this.$el.querySelector(`.${this.options.shareListClass}`);
    }

    if (this.$shareList) {
      this.$shareListClose = this.$shareList.querySelector(`.${this.options.shareCloseClass}`);
      this.$button.addEventListener('click', () => this.showShareList());

      // Initialize ClipboardJS
      document.querySelectorAll('.js-copy').forEach(($copy) => {
        const text = $copy.getAttribute('data-clipboard-text');
        if (ClipboardJS.isSupported()) {
          const clipboard = new ClipboardJS($copy, {
            container: $copy.closest(`.${this.options.shareListClass}`),
            text: () => text,
          });

          clipboard.on('success', () => {
            const $label = $copy.querySelector(`.${this.options.shareListTextClass}`);
            $label.innerHTML = $copy.getAttribute('data-copied-message');
            setTimeout(() => {
              $label.innerHTML = $copy.getAttribute('data-copy-message');
            }, 3000);
          });

          clipboard.on('error', () => {
            clipboard.destroy();
          });
        } else {
          $copy.setAttribute('style', 'display: none;');
        }
      });
    }

    if (this.$shareListClose) {
      this.$shareListClose.addEventListener('click', () => this.closeShareList());
    }

    this.popper = createPopper(this.$button, this.$shareList, {
      placement: popperPlacement,
      modifiers: [
        { name: 'offset', options: { offset: [12, 12] } },
        {
          name: 'arrow',
          options: {
            element: this.$shareList.querySelector(`.${this.options.shareListArrowClass}`),
          },
        },
      ],
    });

    document.addEventListener('click', e => this.onOutsideClick(e));
    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        this.closeShareList();
      }
    });
    this.$el.classList.add(this.options.initializedModifier);
    this.closeShareList();
  }

  showShareList() {
    this.popper.update();
    this.$el.appendChild(this.$shareList);
  }

  closeShareList() {
    if (this.$el.contains(this.$shareList)) {
      this.$el.removeChild(this.$shareList);
    }
  }

  onOutsideClick(event) {
    const $target = event.target;
    const isInside = (
      this.$shareList.contains($target)
      || this.$shareList === $target
      || this.$el.contains($target)
      || this.$el === $target
    );

    if (isInside) {
      return;
    }
    this.closeShareList();
  }

  static initializeAll(jsclass = '.share:not(.share--initialized)') {
    document.querySelectorAll(jsclass).forEach(
      $share => new Share($share),
    );
  }
}

Share.initializeAll(`.${Share.DefaultOptions.elementClass}:not(${Share.DefaultOptions.initializedModifier})`);
